'use strict';

const SELECT_ALL_ITEMS = 'All';

exports.SELECT_ALL_ITEMS = SELECT_ALL_ITEMS;
